export default "__VITE_ASSET__CE0P_KI1__"